import { Button, theme as defaultTheme, Icon } from "@mindlercare/ui-web";
import {
  ButtonProps,
  RegularButtonProps,
} from "@mindlercare/ui-web/src/lib/button";
import { styled } from "styled-components";
import { Typography } from "components/typography";

type AddButtonProps = Pick<ButtonProps, "variant" | "onClick" | "disabled"> & {
  text: string;
};

export const AddButton: React.FC<AddButtonProps> = ({
  variant,
  onClick,
  text,
  disabled = false,
}) => {
  const isSmall = variant.includes("-small");

  return (
    <StyledIconButton
      // this casting for now is just to silence TypeScript errors
      // but maybe we should not have variant link-button and instead have just a link
      variant={variant as RegularButtonProps["variant"]}
      onClick={onClick as RegularButtonProps["onClick"]}
      disabled={disabled}
    >
      <Icon.Add width={isSmall ? 20 : 24} />
      <Typography
        variant={isSmall ? "body-small" : "body"}
        color={"BLACK"}
        sx={{ fontWeight: defaultTheme.FONT.WEIGHT.MEDIUM }}
        insensitive
      >
        {text}
      </Typography>
    </StyledIconButton>
  );
};

const StyledIconButton = styled(Button)<{
  variant: React.ComponentPropsWithoutRef<typeof Button>["variant"];
}>`
  // we need to compensate few pixels of the Add icon.
  // otherwise there is visually more space to the left than to the right
  padding-left: ${({ variant }) =>
    variant !== "link-button" ? "16px" : "0px"};
`;
